import React from 'react';
import Abpr from '../components/About/Abpr';
import TeamSection from '../components/About/TeamSection';
import Footer from '../components/Footer';

function About() {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '50px',
				marginTop: '70px',
			}}
		>
			<Abpr />

			<TeamSection />
			<Footer />
		</div>
	);
}

export default About;
